import React from "react";

export default props => <h1 className="page--title">{props.pageTitle}</h1>